import { createClient } from '@supabase/supabase-js';

/**
 * Supabase client — single instance for the whole app.
 *
 * Reads URL and publishable (anon) key from Vite env vars. These must
 * be defined in .env.local for local dev and in Netlify env vars for
 * production. The publishable key is safe to ship to the browser; Row
 * Level Security on the database is what actually protects user data.
 */

const url = import.meta.env.VITE_SUPABASE_URL;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !key) {
  // Fail loudly during dev so misconfiguration doesn't silently
  // produce broken auth. In production this would only fire if
  // someone forgot to add env vars to Netlify.
  // eslint-disable-next-line no-console
  console.error(
    'Supabase env vars missing. Set VITE_SUPABASE_URL and ' +
      'VITE_SUPABASE_ANON_KEY in .env.local (locally) and in Netlify ' +
      '(production).'
  );
}

export const supabase = createClient(url, key, {
  auth: {
    // Persist the session across reloads (default), and detect the
    // session in the URL when the user returns from a magic link.
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
